// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2XHYn","form":"styles_form__1aLVZ"};